import React from "react";

function Contact() {
  return (
    <div style={{ background: "#f4f6f9", padding: "60px 20px" }}>

      {/* PAGE TITLE */}
      <div style={{ textAlign: "center", marginBottom: "60px" }}>
        <h1 style={{ fontSize: "38px", fontWeight: "700" }}>
          Contact Us
        </h1>
        <p style={{ color: "#777" }}>
          Reach out to us for site visit & property enquiries
        </p>
      </div>

      <div
        style={{
          maxWidth: "1200px",
          margin: "auto",
          display: "flex",
          gap: "40px",
          flexWrap: "wrap"
        }}
      >

        {/* GIRIS GARDENS */}
        <div
          style={{
            flex: 1,
            minWidth: "300px",
            background: "#fff",
            padding: "30px",
            borderRadius: "14px",
            boxShadow: "0 8px 25px rgba(0,0,0,0.05)"
          }}
        >
          <h2 style={{ marginBottom: "20px" }}>Giris Gardens</h2>

          <p style={{ lineHeight: "1.8", color: "#444" }}>
            📍 Ottupattarai, Coonoor,<br />
            Nilgiris, Tamil Nadu – 643105
          </p>

          <p style={{ marginTop: "15px" }}>
            📞 <a href="tel:9585928712">9585928712</a>
          </p>

          <div style={{ marginTop: "25px" }}>
            <iframe
              src="https://www.google.com/maps?q=Ottupattarai,Coonoor,Nilgiris,TamilNadu&output=embed"
              width="100%"
              height="220"
              style={{ border: 0, borderRadius: "10px" }}
              loading="lazy"
              title="giris-location"
            ></iframe>
          </div>
        </div>

        {/* RITHAN PROMOTERS */}
        <div
          style={{
            flex: 1,
            minWidth: "300px",
            background: "#fff",
            padding: "30px",
            borderRadius: "14px",
            boxShadow: "0 8px 25px rgba(0,0,0,0.05)"
          }}
        >
          <h2 style={{ marginBottom: "20px" }}>Rithan Promoters</h2>

          <p style={{ marginBottom: "10px" }}>
            👤 Suresh
          </p>

          <p style={{ lineHeight: "1.8", color: "#444" }}>
            📍 11, Nadu Street,<br />
            Gobichettipalayam,<br />
            Erode District – 638452
          </p>

          <p style={{ marginTop: "15px" }}>
            📞 <a href="tel:7373723163">7373723163</a>
          </p>

          <p>
            📧 <a href="mailto:rithanpromoters@gmail.com">
              rithanpromoters@gmail.com
            </a>
          </p>

          <p>
            🌐 <a
              href="https://www.rithanpromoters.com"
              target="_blank"
              rel="noreferrer"
            >
              www.rithanpromoters.com
            </a>
          </p>

          <div style={{ marginTop: "25px" }}>
            <iframe
              src="https://www.google.com/maps?q=Gobichettipalayam,Erode,TamilNadu&output=embed"
              width="100%"
              height="220"
              style={{ border: 0, borderRadius: "10px" }}
              loading="lazy"
              title="rithan-location"
            ></iframe>
          </div>
        </div>

      </div>

      {/* CONTACT FORM SECTION */}
      <div
        style={{
          maxWidth: "800px",
          margin: "70px auto 0",
          background: "#fff",
          padding: "40px",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(0,0,0,0.05)"
        }}
      >
        <h2 style={{ marginBottom: "25px", textAlign: "center" }}>
          Send Enquiry
        </h2>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            alert("Enquiry Submitted Successfully!");
          }}
        >
          <input
            type="text"
            placeholder="Your Name"
            required
            style={{
              width: "100%",
              padding: "12px",
              marginBottom: "15px"
            }}
          />

          <input
            type="tel"
            placeholder="Phone Number"
            required
            style={{
              width: "100%",
              padding: "12px",
              marginBottom: "15px"
            }}
          />

          <textarea
            placeholder="Your Message"
            rows="4"
            required
            style={{
              width: "100%",
              padding: "12px",
              marginBottom: "15px"
            }}
          ></textarea>

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "12px",
              background: "#111",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              fontWeight: "600",
              cursor: "pointer"
            }}
          >
            Submit Enquiry
          </button>
        </form>
      </div>

    </div>
  );
}

export default Contact;